import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { isMobile } from "react-device-detect";

export default function PropertyCenter({
  userInfo,
  qbSum,
  setVisibleTK,
  setVisibleTK2,
  setVisibleCK,
  isShowZF,
  loanAmount,
  pledgeStatus
}) {
  const c2ctxStatus = localStorage.getItem("c2ctxStatus");
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const companySkin = localStorage.getItem("companySkin");
  
  if (isMobile){
    return (
    <div className="flex flex-col w-full bg-neutral-900 text-neutral-200 min-h-screen ">
      <AcendexLayout theme="light" bottomBarIndex={4}>
        {/* 顶部资产卡片 */}
        <div className="bg-neutral-600 p-4">
          <div className="flex flex-col">
            <div className="mb-2"></div>
            <p className="text-sm text-neutral-200 mb-1">
              {translate(getText("資產"))}
            </p>
            <h1 className="text-2xl font-bold flex items-center">
              {userInfo?.usdt?.toFixed(2)}
              <span className="text-sm ml-2 opacity-80">USDT</span>
            </h1>
            <div className="h-2"></div>
          </div>
        </div>

        {/* 操作按钮区域 */}
        <div className="grid grid-cols-4 gap-2 p-4 bg-neutral-800">
          <div
            className="flex flex-col items-center justify-center p-3 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer"
            onClick={() => {
              navigate("/rechargelist");
            }}
          >
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center mb-2">
              <img src="/ICON/20.png" className="w-5 h-5" />
            </div>
            <p className="text-xs">
              <div>{translate(getText("入金"))}</div>
            </p>
          </div>

          <div
            className="flex flex-col items-center justify-center p-3 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer"
            onClick={() => {
              navigate("/extractlist");
            }}
          >
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center mb-2">
              <img src="/ICON/21.png" className="w-5 h-5" />
            </div>
            <p className="text-xs">
              <div>{translate(getText("出金"))}</div>
            </p>
          </div>

          <div
            className="flex flex-col items-center justify-center p-3 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer"
            onClick={() => {
              navigate("/addresslist");
            }}
          >
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center mb-2">
              <img src="/ICON/22.png" className="w-5 h-5" />
            </div>
            <p className="text-xs">
              <div>{translate(getText("地址"))}</div>
            </p>
          </div>

          {pledgeStatus == 1 && (
            <div
              className="flex flex-col items-center justify-center p-3 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer"
              onClick={() => {
                navigate("/pledgeBack");
              }}
            >
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center mb-2">
                <img src="/ICON/20.png" className="w-5 h-5" />
              </div>
              <p className="text-xs">
                <div>{translate(getText("還款"))}</div>
              </p>
            </div>
          )}
        </div>

        {/* 标签页标题 */}
        <div className="px-4 pt-4">
          <div className="border-b border-neutral-700">
            <div className="flex">
              <div className="relative">
                <div className="pb-2">
                  <div className="text-sm font-medium text-primary border-b-2 border-primary pb-2">
                    {translate(getText("賬戶資產"))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 资产列表 */}
        <ul className="p-4">
          <li className="bg-neutral-800 rounded-lg overflow-hidden mb-4">
            <div className="px-4 py-3 border-b border-neutral-700">
              <h1 className="text-lg font-medium">USDT</h1>
            </div>
            <div className="p-4">
              <div className="grid grid-cols-3 gap-2 text-xs text-neutral-400 mb-2">
                <div>{translate(getText("可用"))}(USDT)</div>
                <div>{translate(getText("處理中"))}(USDT)</div>
                <div>{translate(getText("折合"))}(USDT)</div>
              </div>
              <div className="grid grid-cols-3 gap-2 text-sm">
                <div>{userInfo?.usdt?.toFixed(2)}</div>
                <div>0.00</div>
                <div>{userInfo?.usdt?.toFixed(2)}</div>
              </div>
            </div>
          </li>
        </ul>

        {/* 借款信息 */}
        {pledgeStatus == 1 && (
          <ul className="px-4 pb-4">
            <li className="bg-neutral-800 rounded-lg overflow-hidden">
              <div className="px-4 py-3 border-b border-neutral-700">
                <h1 className="text-lg font-medium">
                  {translate(getText("借款"))}
                </h1>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-3 gap-2 text-xs text-neutral-400 mb-2">
                  <div>{translate(getText("可用"))}(USDT)</div>
                  <div>{translate(getText("處理中"))}(USDT)</div>
                  <div>{translate(getText("借幣金額"))}(USDT)</div>
                </div>
                <div className="grid grid-cols-3 gap-2 text-sm">
                  <div>{userInfo?.usdt?.toFixed(2)}</div>
                  <div>0.00</div>
                  <div>{loanAmount.toFixed(2)}</div>
                </div>
              </div>
            </li>
          </ul>
        )}
      </AcendexLayout>
    </div>
  )
  }
  return (
    <div className="flex flex-col w-full bg-neutral-900 text-neutral-200 min-h-screen">
      <AcendexLayout theme="light" bottomBarIndex={4}>
        <div className="container mx-auto px-6 py-8 max-w-screen-xl">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* 左侧资产卡片和操作按钮 */}
            <div className="lg:col-span-1">
              {/* 顶部资产卡片 */}
              <div className="bg-gradient-primary p-6 rounded-xl shadow-lg mb-6">
                <div className="flex flex-col">
                  <p className="text-base text-neutral-800 mb-2 opacity-80">
                    {translate(getText("資產"))}
                  </p>
                  <h1 className="text-3xl font-bold flex items-center mb-2 text-neutral-900">
                    {userInfo?.usdt?.toFixed(2)}
                    <span className="text-base ml-2 opacity-80">USDT</span>
                  </h1>
                </div>
              </div>

              {/* 操作按钮区域 */}
              <div className="bg-neutral-800 rounded-xl shadow-lg p-6">
                <h2 className="text-xl font-semibold mb-4">
                  {translate(getText("操作"))}
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <div
                    className="flex flex-col items-center justify-center p-4 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer hover:shadow-lg"
                    onClick={() => {
                      navigate("/rechargelist");
                    }}
                  >
                    <div className="w-12 h-12 rounded-full  flex items-center justify-center mb-3">
                      <img src="/ICON/20.png" className="size-12" />
                    </div>
                    <p className="text-sm font-medium">
                      {translate(getText("入金"))}
                    </p>
                  </div>

                  <div
                    className="flex flex-col items-center justify-center p-4 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer hover:shadow-lg"
                    onClick={() => {
                      navigate("/extractlist");
                    }}
                  >
                    <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3">
                      <img src="/ICON/21.png" className="size-12" />
                    </div>
                    <p className="text-sm font-medium">
                      {translate(getText("出金"))}
                    </p>
                  </div>

                  <div
                    className="flex flex-col items-center justify-center p-4 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer hover:shadow-lg"
                    onClick={() => {
                      navigate("/addresslist");
                    }}
                  >
                    <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3">
                      <img src="/ICON/22.png" className="size-12" />
                    </div>
                    <p className="text-sm font-medium">
                      {translate(getText("地址"))}
                    </p>
                  </div>

                  {pledgeStatus == 1 && (
                    <div
                      className="flex flex-col items-center justify-center p-4 rounded-lg bg-neutral-700 hover:bg-neutral-600 transition-all cursor-pointer hover:shadow-lg"
                      onClick={() => {
                        navigate("/pledgeBack");
                      }}
                    >
                      <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3">
                        <img src="/ICON/20.png" className="size-12" />
                      </div>
                      <p className="text-sm font-medium">
                        {translate(getText("還款"))}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* 右侧账户资产和借款信息 */}
            <div className="lg:col-span-2">
              {/* 标签页标题 */}
              <div className="bg-neutral-800 rounded-xl shadow-lg p-6 mb-6">
                <div className="border-b border-neutral-700 mb-4">
                  <div className="flex">
                    <div className="relative">
                      <div className="pb-2">
                        <div className="text-lg font-semibold text-primary border-b-2 border-primary pb-2">
                          {translate(getText("賬戶資產"))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 资产列表 */}
                <div className="bg-neutral-700 rounded-lg overflow-hidden mb-4">
                  <div className="flex justify-between items-center px-6 py-4 border-b border-neutral-600">
                    <h1 className="text-xl font-medium">USDT</h1>
                    <div className="flex items-center gap-2">
                      {/* <span className="w-2 h-2 rounded-full bg-green-500"></span> */}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="grid grid-cols-3 gap-8 text-sm text-neutral-400 mb-3">
                      <div>{translate(getText("可用"))}(USDT)</div>
                      <div>{translate(getText("處理中"))}(USDT)</div>
                      <div>{translate(getText("折合"))}(USDT)</div>
                    </div>
                    <div className="grid grid-cols-3 gap-8 text-lg">
                      <div>{userInfo?.usdt?.toFixed(2)}</div>
                      <div>0.00</div>
                      <div>{userInfo?.usdt?.toFixed(2)}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 借款信息 */}
              {pledgeStatus == 1 && (
                <div className="bg-neutral-800 rounded-xl shadow-lg p-6">
                  <div className="border-b border-neutral-700 mb-4">
                    <h1 className="text-lg font-semibold text-primary pb-2">
                      {translate(getText("借款详情"))}
                    </h1>
                  </div>
                  <div className="bg-neutral-700 rounded-lg overflow-hidden">
                    <div className="flex justify-between items-center px-6 py-4 border-b border-neutral-600">
                      <h1 className="text-xl font-medium">
                        {translate(getText("借款"))}
                      </h1>
                    </div>
                    <div className="p-6">
                      <div className="grid grid-cols-3 gap-8 text-sm text-neutral-400 mb-3">
                        <div>{translate(getText("可用"))}(USDT)</div>
                        <div>{translate(getText("處理中"))}(USDT)</div>
                        <div>{translate(getText("借幣金額"))}(USDT)</div>
                      </div>
                      <div className="grid grid-cols-3 gap-8 text-lg">
                        <div>{userInfo?.usdt?.toFixed(2)}</div>
                        <div>0.00</div>
                        <div>{loanAmount.toFixed(2)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AcendexLayout>
    </div>
  );
}
